/**
 * VoiceOver reads single character in table cell as 'blank'.
 * Adding extra character to avoid missing the content.
 */
export function fixTableCellValue(value) {
  return value && `${value}`.length === 1 ? `${value}&nbsp;` : value;
}
